module.exports = __webpack_public_path__ + "new_mygolf2u_logo.86f1f00c828966a8f0d3.png";


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/assets/images/new_mygolf2u_logo.png
// module id = ../../../../../src/assets/images/new_mygolf2u_logo.png
// module chunks = styles